import _ from 'lodash';

export default {
  props: ['value'],
  data() {
    return {
      data: null
    };
  },

  computed: {
    hasDifference() {
      return !_.isEqual(this.value, this.data);
    }
  },

  watch: {
    value: {
      deep: true,
      handler() {
        if (this.hasDifference) {
          this.applyInput();
        }
      }
    },

    data: {
      deep: true,
      handler() {
        if (this.hasDifference) {
          this.$emit('input', this.data);
        }
      }
    }
  },

  mounted() {
    this.applyInput();
  },

  methods: {
    applyInput() {
      this.$set(this, 'data', JSON.parse(JSON.stringify(this.value)));
    }
  }
};
